import { roman } from "./Ornament";

const RITUAL = [
  "Surveying what you already stand on",
  "Marking the hard prerequisites",
  "Tracing the soft context",
  "Ordering the route, step by step",
  "Placing your destination on the map",
];

const CompassNeedle = () => (
  <svg viewBox="0 0 200 200" className="h-40 w-40 sm:h-48 sm:w-48" aria-hidden data-testid="loading-compass">
    <circle cx="100" cy="100" r="96" fill="hsl(var(--card))" stroke="hsl(var(--primary) / 0.6)" strokeWidth="1" />
    <circle cx="100" cy="100" r="86" fill="none" stroke="hsl(var(--primary) / 0.35)" strokeWidth="0.7" strokeDasharray="1.5 4" />
    <g stroke="hsl(var(--primary) / 0.7)" strokeWidth="0.8">
      {Array.from({ length: 36 }).map((_, i) => {
        const a = (i * Math.PI) / 18;
        const long = i % 9 === 0;
        return (
          <line
            key={i}
            x1={100 + Math.cos(a) * 96}
            y1={100 + Math.sin(a) * 96}
            x2={100 + Math.cos(a) * (long ? 82 : 90)}
            y2={100 + Math.sin(a) * (long ? 82 : 90)}
          />
        );
      })}
    </g>
    {["N", "E", "S", "W"].map((c, i) => {
      const a = (i * Math.PI) / 2 - Math.PI / 2;
      return (
        <text
          key={c}
          x={100 + Math.cos(a) * 68}
          y={100 + Math.sin(a) * 68 + 5}
          textAnchor="middle"
          fontSize="13"
          fontFamily="Fraunces, Georgia, serif"
          fill="hsl(var(--primary))"
        >
          {c}
        </text>
      );
    })}
    <g className="needle-settle" style={{ transformOrigin: "100px 100px" }}>
      <path d="M100 30 L108 100 L100 108 L92 100 Z" fill="hsl(var(--primary))" />
      <path d="M100 170 L108 100 L100 92 L92 100 Z" fill="hsl(var(--foreground) / 0.5)" />
    </g>
    <circle cx="100" cy="100" r="5" fill="hsl(var(--background))" stroke="hsl(var(--primary))" strokeWidth="1.5" />
  </svg>
);

export const LoadingRitual = ({ destination }) => (
  <section
    data-testid="loading-ritual"
    className="relative max-w-2xl mx-auto px-4 sm:px-6 pt-14 pb-24 text-center atlas-rise"
  >
    <div className="mx-auto mb-8 grid place-items-center">
      <CompassNeedle />
    </div>
    <span className="eyebrow text-destructive">Sketching a DRAFT route · AI-generated · not in the Atlas</span>
    <h2 className="font-display font-medium tracking-tight text-3xl sm:text-4xl leading-[1.05] mt-2">
      Toward <span className="italic text-primary">{destination}</span>…
    </h2>

    <ol className="mt-10 max-w-md mx-auto text-left space-y-3.5">
      {RITUAL.map((line, i) => (
        <li
          key={line}
          data-testid={`ritual-step-${i}`}
          className="ink-in flex items-center gap-4"
          style={{ animationDelay: `${0.1 + i * 0.15}s` }}
        >
          <span className="numeral text-primary text-sm w-7 shrink-0 text-right">{roman(i + 1)}.</span>
          <span className="relative font-display italic text-base sm:text-lg text-foreground/90">
            {line}
            <span className="ink-line absolute left-0 -bottom-1 h-px bg-primary/50" style={{ animationDelay: `${0.2 + i * 0.15}s` }} />
          </span>
        </li>
      ))}
    </ol>
  </section>
);
